
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/inventory`;

export const inventoryService = {

    getOrderList: async function (siteCode: string, productCode: string) {
        return axios.get(`${GATEWAY_URL}/inventory_list`, {
            params: {
                LocationCode: siteCode,
                ProductCode: productCode,
                LocationTypeCode: "S"
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderDetailList: async function (siteCode: string, productCode: string) {
        return axios.get(`${GATEWAY_URL}/inventory_transaction_list`, {
            params: {
                SiteCode: siteCode,
                ProductCode: productCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getSiteLookups: async function () {
        return axios.get(`${GATEWAY_URL}/inventory_location_lookup`, {
            params: {
                LocationTypeCode: "S"
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductLookups: async function (locationCode:string) {
        return axios.get(`${GATEWAY_URL}/inventory_product_lookup`, {
            params: {
                LocationTypeCode: "S",
                LocationCode:locationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },


    paymentTypeLookup: async function () {
        return axios.get(`${GATEWAY_URL}/inventory_types_lookup`, {
            params: {
                LocationTypeCode: "S"
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    savePayment: async function (values: any) {
        return axios.post(`${GATEWAY_URL}/site_inventory_transaction_save`, values)
            .then((response) => {
                return response.data;
            });
    },

    deletePayment: async function (values: any) {
        return axios.post(`${GATEWAY_URL}/inventory_transaction_delete`, { id: values })
            .then((response) => {
                return response.data;
            });
    },

}
